module.exports = __webpack_public_path__ + "static/img/11.cc954c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/11.png
// module id = 2MqL
// module chunks = 0